export default "__VITE_ASSET__CsTNpjFP__"